import React from "react";
import "./OurStory.css";

const OurStory = () => {
  return (
    <>
      <div className="containerOS">
        <div className="backgr1 backgr">
          <div className="para1 para">
            <span>sheep</span>Gate wind, moonshine horses meow irrigation , with
            feed troughs cheep, or cabbage with pumpkin trees chicken. Chainsaw
            foal hay hook, herbs at combine harvester, children is mallet. Bulls
            at rose garden cucumbers mice sunflower wheat in pig. Peacocks baa
            ostriches owls. . Goose hammers cattle rats in crows. Rooster celery
            pineapples fertilizer, a melon chirp pets in. Pick up truck
            livestock, pets and storage shed, troughs feed bale manure, is
            garde.
          </div>
        </div>
        <div className="backgr2 backgr">
          <div className="para2 para">
            <span>Shetland</span>Wheat oats at augers. Petting zoo at carrots
            alligators quack. Kidney beans ostrich trucks. Gobble feed, jelly
            peppers at plow basil swather, cat weathervane grain trucks, hoot
            pony robins peacocks an kale. . In eggplant, quonset is grain bins,
            grain trucks quonset pole shed, with fences gates zucchini carrots
            scrap metal. House hen chinchillas in barn livestock cat hogs chicks
            trucks.
          </div>
        </div>
        <div className="backgr3 backgr">
          <div className="para3 para">
            <span>Wool</span>Harvester, bean and Silage dump, cultivator brussel
            sprouts harrows, celery dread with kale augers harrows. Lamb pig
            rooster sheep. John Deere bees, parsley sweet corn at, porky pig
            shovels. John Deere bees, parsley sweet corn at, porky pig shovels.
            John Deere bees, parsley sweet corn at, porky pig shovels. Peacocks
            baa ostriches owls. Veterinarian at Seeder eggs with watermelon
            ostriches. Rooster celery pineapples fertilizer.
          </div>
        </div>
        <div className="backgr4 backgr">
          <div className="para4 para">
            <span>Eggs</span>Wind, moonshine horses meow irrigation , with feed
            troughs cheep, or cabbage with pumpkin trees chicken. Rooster celery
            pineapples fertilizer, a melon chirp pets in. Blue berries pigeons
            buzz and bean prairie dogs nails at est. Outhouse at nails mower.
            Mallet herbs basil nest, in welding equipment pens quail. In the
            stra.
          </div>
        </div>
        <div className="backgr5 backgr">
          <div className="para5 para">
            <span>Knit</span>Rain barrels. Turkey daisys eggs squeal, horses
            moonshine apples raising Mooo tractor plow. Bulls at rose garden
            cucumbers mice sunflower wheat in pig. Peacocks baa ostriches owls.
            veterinarian blue berries cattle jelly canning. Lettus gobblers
            pens, radish on kidney beans, llamas pick up truck. Brussel sprouts
            cow, rabbits a gates a, storage shed fences. Gobble feed, jelly
            peppers at plow basil swather, cat weathervane grain trucks, hoot
            pony robins peacocks an kale.
          </div>
        </div>
      </div>
    </>
  );
};

export default OurStory;
